import React from "react";
import { Link } from "react-router";

const RoundLink = ({
  round,
  to,
  params,
  ...props
}) => {
  let otherParams = '';
  if (params) {
    params.forEach(param => {
      otherParams += `&${param.name}=${param.value}`;
    });
  }
  return (
    <Link
      to={`${to}?round=${round}${otherParams}`}
      {...props}
      {...(params ? { target: '_self' } : {})}
    />
  )
};

export default RoundLink;



// WEBPACK FOOTER //
// ./src/components/round-link/index.js